"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const react_1 = __importDefault(require("react"));

const styles_1 = require("@mui/material/styles");

const material_1 = require("@mui/material");

const muiTheme = (0, styles_1.createTheme)((0, material_1.adaptV4Theme)({
  palette: {
    primary: {
      light: "#00b3ea",
      main: "#00A9E0",
      dark: "#0091c8",
      contrastText: "#fff"
    },
    secondary: {
      main: "#fff"
    },
    error: {
      main: "#ff3333",
      contrastText: "#fff"
    },
    text: {
      primary: "#fff",
      secondary: "rgba(255, 255, 255, 0.7)"
    },
    action: {
      active: "rgba(0, 0, 0, 0.54)",
      selected: "rgba(0, 0, 0, 0.08)",
      hover: "rgba(0, 0, 0, 0.04)",
      disabled: "rgba(255, 255, 255, 0.3)",
      disabledBackground: "rgba(255, 255, 255, 0.12)"
    },
    divider: "rgba(255, 255, 255, 0.12)"
  },
  overrides: {
    MuiPaper: {
      root: {
        backgroundColor: "#424242"
      }
    },
    MuiTableRow: {
      root: {
        "&.Mui-selected": {
          backgroundColor: "rgba(0, 169, 224, 0.1)",
          "&:hover": {
            backgroundColor: "rgba(0, 169, 224, 0.1)"
          }
        },
        "td": {
          borderBottom: "1px solid rgba(81, 81, 81, 1)"
        }
      }
    },
    MuiInput: {
      underline: {
        "&:before": {
          borderBottom: "1px solid rgba(255, 255, 255, 0.7)"
        },
        "&:hover:not($disabled):not($focused):not($error):before": {
          borderBottom: "2px solid #fff"
        }
      }
    },
    MuiLink: {
      root: {
        textDecoration: "none",
        "&:hover": {
          textDecoration: "inherit"
        }
      }
    },
    MuiAccordion: {
      root: {
        "& .MuiAccordionSummary-root.Mui-expanded": {
          minHeight: "50px"
        }
      }
    }
  },
  spacing: factor => `${8 * factor}px`
}));

function SskyMuiDarkTheme(props) {
  return react_1.default.createElement(styles_1.ThemeProvider, {
    theme: muiTheme
  }, props.children);
}

exports.default = SskyMuiDarkTheme;
;